<template>
  <svg width="26" height="26" xmlns="http://www.w3.org/2000/svg" :stroke="!!this.orange ? '#F75F39' : '#fff'">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(1 1)" stroke-width="2">
        <circle stroke-opacity=".5" cx="12" cy="12" r="12" />
        <path d="M24 12c0-9.94-8.06-12-12-12">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 12 12"
            to="360 12 12"
            dur="1s"
            repeatCount="indefinite" />
        </path>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      orange: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    name: "Spinner"
  }
</script>

<style scoped>

</style>
